export class SankeyConfig {
  colors: Array<string>;
  constructor(colors: Array<string>) {
    this.colors = colors;
  }
}